import React from "react";
import { Navigate } from "react-router-dom";

function RedirectView() {
  return <Navigate to="/" />;
}

export default RedirectView;
